document.addEventListener('DOMContentLoaded', function () {
    const container = document.querySelector('.ingredients-card-container');

    if (container) {
        const sliderWrapper = container.querySelector('.ingredients-slider-wrapper');
        const slides = container.querySelectorAll('.ingredient-card');
        const dots = container.querySelectorAll('.ingredients-dot');
        const prevBtn = container.querySelector('.ingredients-prev');
        const nextBtn = container.querySelector('.ingredients-next');

        let currentIndex = 0;
        const totalSlides = slides.length;

        function calculateMaxHeight() {
            let maxHeight = 0;
            slides.forEach((slide) => {
                const inner = slide.querySelector('.ingredient-card__inner');
                if (inner) {
                    maxHeight = Math.max(maxHeight, inner.getBoundingClientRect().height);
                }
            });

            if (maxHeight > 0) {
                sliderWrapper.style.height = maxHeight + 'px';
                const backFaces = container.querySelectorAll('.ingredient-card__face--back');
                backFaces.forEach((face) => {
                    face.style.height = maxHeight + 'px';
                });
            }
        }

        function updateSlider(index) {
            if (index < 0) index = totalSlides - 1;
            if (index >= totalSlides) index = 0;

            currentIndex = index;

            slides.forEach((slide) => {
                slide.classList.remove('is-active');
                slide.classList.remove('is-flipped');
                if (parseInt(slide.dataset.index) === currentIndex) {
                    slide.classList.add('is-active');
                }
            });

            dots.forEach((dot) => {
                dot.classList.remove('is-active');
                if (parseInt(dot.dataset.index) === currentIndex) {
                    dot.classList.add('is-active');
                }
            });
        }

        const toggles = container.querySelectorAll('.ingredient-card__toggle');
        toggles.forEach((toggle) => {
            toggle.addEventListener('click', (e) => {
                e.stopPropagation();
                const card = e.target.closest('.ingredient-card');
                card.classList.toggle('is-flipped');
            });
        });

        // Add click event to the entire card
        slides.forEach((slide) => {
            slide.addEventListener('click', () => {
                slide.classList.toggle('is-flipped');
            });
        });

        if (prevBtn) {
            prevBtn.addEventListener('click', () => {
                updateSlider(currentIndex - 1);
            });
        }

        if (nextBtn) {
            nextBtn.addEventListener('click', () => {
                updateSlider(currentIndex + 1);
            });
        }

        dots.forEach((dot) => {
            dot.addEventListener('click', () => {
                const index = parseInt(dot.dataset.index);
                updateSlider(index);
            });
        });

        calculateMaxHeight();
        window.addEventListener('resize', calculateMaxHeight);
        window.addEventListener('load', calculateMaxHeight);
    }

    let iconSwiper = null;

    function initIconSwiper() {
        if (window.innerWidth < 1280 && !iconSwiper) {
            iconSwiper = new Swiper('.icons-marquee', {
                slidesPerView: 'auto',
                centeredSlides: false,
                spaceBetween: 5,
                loop: true,
                speed: 5000,
                autoplay: {
                    delay: 0,
                    disableOnInteraction: false,
                },
                allowTouchMove: false,
            });
        } else if (window.innerWidth >= 1280 && iconSwiper) {
            iconSwiper.destroy(true, true);
            iconSwiper = null;
        }
    }

    initIconSwiper();
    window.addEventListener('resize', initIconSwiper);
});
